// Entry point for Editor module
import Editor from './Editor';
export default Editor;
